import React, { Component } from 'react';
import '../dashboard/scss/style.scss';
import Layout from '../dashboard/Layout';
import Authenticate from './Authenticate';

export default class Dashboard extends Component {
	render() {
		return (
			<div className="dashboard_wrapper">
				<Authenticate Component={<Layout />} role='SELLER' />
			</div>
		);
	}
}
